// Phone codes for compliant countries (excludes sanctioned jurisdictions)
// Excludes: Cuba, Myanmar/Burma, Iran, North Korea, Russia, Belarus, and other sanctioned territories

export interface PhoneCode {
  code: string;
  country: string;
  flag: string; // kept for backward compat, prefer iso2
  iso2: string; // ISO 3166-1 alpha-2 for flagcdn.com image rendering
}

export const phoneCodes: PhoneCode[] = [
  // UK & Ireland
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧', iso2: 'GB' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', iso2: 'IE' },
  
  // Europe
  { code: '+355', country: 'Albania', flag: '🇦🇱', iso2: 'AL' },
  { code: '+376', country: 'Andorra', flag: '🇦🇩', iso2: 'AD' },
  { code: '+43', country: 'Austria', flag: '🇦🇹', iso2: 'AT' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', iso2: 'BE' },
  { code: '+387', country: 'Bosnia and Herzegovina', flag: '🇧🇦', iso2: 'BA' },
  { code: '+359', country: 'Bulgaria', flag: '🇧🇬', iso2: 'BG' },
  { code: '+385', country: 'Croatia', flag: '🇭🇷', iso2: 'HR' },
  { code: '+357', country: 'Cyprus', flag: '🇨🇾', iso2: 'CY' },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿', iso2: 'CZ' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', iso2: 'DK' },
  { code: '+372', country: 'Estonia', flag: '🇪🇪', iso2: 'EE' },
  { code: '+358', country: 'Finland', flag: '🇫🇮', iso2: 'FI' },
  { code: '+33', country: 'France', flag: '🇫🇷', iso2: 'FR' },
  { code: '+49', country: 'Germany', flag: '🇩🇪', iso2: 'DE' },
  { code: '+30', country: 'Greece', flag: '🇬🇷', iso2: 'GR' },
  { code: '+36', country: 'Hungary', flag: '🇭🇺', iso2: 'HU' },
  { code: '+354', country: 'Iceland', flag: '🇮🇸', iso2: 'IS' },
  { code: '+39', country: 'Italy', flag: '🇮🇹', iso2: 'IT' },
  { code: '+371', country: 'Latvia', flag: '🇱🇻', iso2: 'LV' },
  { code: '+423', country: 'Liechtenstein', flag: '🇱🇮', iso2: 'LI' },
  { code: '+370', country: 'Lithuania', flag: '🇱🇹', iso2: 'LT' },
  { code: '+352', country: 'Luxembourg', flag: '🇱🇺', iso2: 'LU' },
  { code: '+356', country: 'Malta', flag: '🇲🇹', iso2: 'MT' },
  { code: '+373', country: 'Moldova', flag: '🇲🇩', iso2: 'MD' },
  { code: '+377', country: 'Monaco', flag: '🇲🇨', iso2: 'MC' },
  { code: '+382', country: 'Montenegro', flag: '🇲🇪', iso2: 'ME' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', iso2: 'NL' },
  { code: '+389', country: 'North Macedonia', flag: '🇲🇰', iso2: 'MK' },
  { code: '+47', country: 'Norway', flag: '🇳🇴', iso2: 'NO' },
  { code: '+48', country: 'Poland', flag: '🇵🇱', iso2: 'PL' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', iso2: 'PT' },
  { code: '+40', country: 'Romania', flag: '🇷🇴', iso2: 'RO' },
  { code: '+378', country: 'San Marino', flag: '🇸🇲', iso2: 'SM' },
  { code: '+381', country: 'Serbia', flag: '🇷🇸', iso2: 'RS' },
  { code: '+421', country: 'Slovakia', flag: '🇸🇰', iso2: 'SK' },
  { code: '+386', country: 'Slovenia', flag: '🇸🇮', iso2: 'SI' },
  { code: '+34', country: 'Spain', flag: '🇪🇸', iso2: 'ES' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', iso2: 'SE' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', iso2: 'CH' },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦', iso2: 'UA' },
  
  // North America
  { code: '+1', country: 'United States', flag: '🇺🇸', iso2: 'US' },
  { code: '+1', country: 'Canada', flag: '🇨🇦', iso2: 'CA' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', iso2: 'MX' },
  
  // Central America & Caribbean (excluding sanctioned)
  { code: '+1246', country: 'Barbados', flag: '🇧🇧', iso2: 'BB' },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷', iso2: 'CR' },
  { code: '+1767', country: 'Dominica', flag: '🇩🇲', iso2: 'DM' },
  { code: '+1809', country: 'Dominican Republic', flag: '🇩🇴', iso2: 'DO' },
  { code: '+503', country: 'El Salvador', flag: '🇸🇻', iso2: 'SV' },
  { code: '+1473', country: 'Grenada', flag: '🇬🇩', iso2: 'GD' },
  { code: '+502', country: 'Guatemala', flag: '🇬🇹', iso2: 'GT' },
  { code: '+504', country: 'Honduras', flag: '🇭🇳', iso2: 'HN' },
  { code: '+1876', country: 'Jamaica', flag: '🇯🇲', iso2: 'JM' },
  { code: '+505', country: 'Nicaragua', flag: '🇳🇮', iso2: 'NI' },
  { code: '+1787', country: 'Puerto Rico', flag: '🇵🇷', iso2: 'PR' },
  { code: '+1869', country: 'Saint Kitts and Nevis', flag: '🇰🇳', iso2: 'KN' },
  { code: '+1758', country: 'Saint Lucia', flag: '🇱🇨', iso2: 'LC' },
  { code: '+1784', country: 'Saint Vincent and the Grenadines', flag: '🇻🇨', iso2: 'VC' },
  
  // South America
  { code: '+54', country: 'Argentina', flag: '🇦🇷', iso2: 'AR' },
  { code: '+591', country: 'Bolivia', flag: '🇧🇴', iso2: 'BO' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', iso2: 'BR' },
  { code: '+56', country: 'Chile', flag: '🇨🇱', iso2: 'CL' },
  { code: '+57', country: 'Colombia', flag: '🇨🇴', iso2: 'CO' },
  { code: '+593', country: 'Ecuador', flag: '🇪🇨', iso2: 'EC' },
  { code: '+592', country: 'Guyana', flag: '🇬🇾', iso2: 'GY' },
  { code: '+595', country: 'Paraguay', flag: '🇵🇾', iso2: 'PY' },
  { code: '+51', country: 'Peru', flag: '🇵🇪', iso2: 'PE' },
  { code: '+597', country: 'Suriname', flag: '🇸🇷', iso2: 'SR' },
  { code: '+598', country: 'Uruguay', flag: '🇺🇾', iso2: 'UY' },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪', iso2: 'VE' },
  
  // Oceania (excluding sanctioned)
  { code: '+61', country: 'Australia', flag: '🇦🇺', iso2: 'AU' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', iso2: 'NZ' },
  { code: '+675', country: 'Papua New Guinea', flag: '🇵🇬', iso2: 'PG' },
  { code: '+676', country: 'Tonga', flag: '🇹🇴', iso2: 'TO' },
  { code: '+688', country: 'Tuvalu', flag: '🇹🇻', iso2: 'TV' },
  { code: '+686', country: 'Kiribati', flag: '🇰🇮', iso2: 'KI' },
  { code: '+692', country: 'Marshall Islands', flag: '🇲🇭', iso2: 'MH' },
  { code: '+691', country: 'Micronesia', flag: '🇫🇲', iso2: 'FM' },
  { code: '+674', country: 'Nauru', flag: '🇳🇷', iso2: 'NR' },
  { code: '+677', country: 'Solomon Islands', flag: '🇸🇧', iso2: 'SB' },
  
  // Asia
  { code: '+81', country: 'Japan', flag: '🇯🇵', iso2: 'JP' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', iso2: 'KR' },
  { code: '+86', country: 'China', flag: '🇨🇳', iso2: 'CN' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰', iso2: 'HK' },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼', iso2: 'TW' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', iso2: 'SG' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', iso2: 'MY' },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', iso2: 'TH' },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳', iso2: 'VN' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', iso2: 'PH' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', iso2: 'ID' },
  { code: '+91', country: 'India', flag: '🇮🇳', iso2: 'IN' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', iso2: 'BD' },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', iso2: 'PK' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', iso2: 'LK' },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', iso2: 'NP' },
  { code: '+975', country: 'Bhutan', flag: '🇧🇹', iso2: 'BT' },
  { code: '+960', country: 'Maldives', flag: '🇲🇻', iso2: 'MV' },
  { code: '+855', country: 'Cambodia', flag: '🇰🇭', iso2: 'KH' },
  { code: '+856', country: 'Laos', flag: '🇱🇦', iso2: 'LA' },
  { code: '+673', country: 'Brunei', flag: '🇧🇳', iso2: 'BN' },
  { code: '+976', country: 'Mongolia', flag: '🇲🇳', iso2: 'MN' },
  { code: '+7', country: 'Kazakhstan', flag: '🇰🇿', iso2: 'KZ' },
  { code: '+998', country: 'Uzbekistan', flag: '🇺🇿', iso2: 'UZ' },
  { code: '+993', country: 'Turkmenistan', flag: '🇹🇲', iso2: 'TM' },
  { code: '+992', country: 'Tajikistan', flag: '🇹🇯', iso2: 'TJ' },
  { code: '+996', country: 'Kyrgyzstan', flag: '🇰🇬', iso2: 'KG' },
  { code: '+994', country: 'Azerbaijan', flag: '🇦🇿', iso2: 'AZ' },
  { code: '+374', country: 'Armenia', flag: '🇦🇲', iso2: 'AM' },
  { code: '+995', country: 'Georgia', flag: '🇬🇪', iso2: 'GE' },
  
  // Middle East (excluding sanctioned)
  { code: '+971', country: 'United Arab Emirates', flag: '🇦🇪', iso2: 'AE' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', iso2: 'SA' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', iso2: 'QA' },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', iso2: 'KW' },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', iso2: 'BH' },
  { code: '+968', country: 'Oman', flag: '🇴🇲', iso2: 'OM' },
  { code: '+962', country: 'Jordan', flag: '🇯🇴', iso2: 'JO' },
  { code: '+961', country: 'Lebanon', flag: '🇱🇧', iso2: 'LB' },
  { code: '+972', country: 'Israel', flag: '🇮🇱', iso2: 'IL' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', iso2: 'TR' },
  { code: '+964', country: 'Iraq', flag: '🇮🇶', iso2: 'IQ' },
  
  // Africa (excluding sanctioned)
  { code: '+27', country: 'South Africa', flag: '🇿🇦', iso2: 'ZA' },
  { code: '+20', country: 'Egypt', flag: '🇪🇬', iso2: 'EG' },
  { code: '+212', country: 'Morocco', flag: '🇲🇦', iso2: 'MA' },
  { code: '+216', country: 'Tunisia', flag: '🇹🇳', iso2: 'TN' },
  { code: '+213', country: 'Algeria', flag: '🇩🇿', iso2: 'DZ' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', iso2: 'NG' },
  { code: '+233', country: 'Ghana', flag: '🇬🇭', iso2: 'GH' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', iso2: 'KE' },
  { code: '+255', country: 'Tanzania', flag: '🇹🇿', iso2: 'TZ' },
  { code: '+256', country: 'Uganda', flag: '🇺🇬', iso2: 'UG' },
  { code: '+250', country: 'Rwanda', flag: '🇷🇼', iso2: 'RW' },
  { code: '+251', country: 'Ethiopia', flag: '🇪🇹', iso2: 'ET' },
  { code: '+221', country: 'Senegal', flag: '🇸🇳', iso2: 'SN' },
  { code: '+225', country: 'Ivory Coast', flag: '🇨🇮', iso2: 'CI' },
  { code: '+237', country: 'Cameroon', flag: '🇨🇲', iso2: 'CM' },
  { code: '+244', country: 'Angola', flag: '🇦🇴', iso2: 'AO' },
  { code: '+258', country: 'Mozambique', flag: '🇲🇿', iso2: 'MZ' },
  { code: '+260', country: 'Zambia', flag: '🇿🇲', iso2: 'ZM' },
  { code: '+263', country: 'Zimbabwe', flag: '🇿🇼', iso2: 'ZW' },
  { code: '+267', country: 'Botswana', flag: '🇧🇼', iso2: 'BW' },
  { code: '+264', country: 'Namibia', flag: '🇳🇦', iso2: 'NA' },
  { code: '+230', country: 'Mauritius', flag: '🇲🇺', iso2: 'MU' },
  { code: '+261', country: 'Madagascar', flag: '🇲🇬', iso2: 'MG' },
  { code: '+265', country: 'Malawi', flag: '🇲🇼', iso2: 'MW' },
  { code: '+229', country: 'Benin', flag: '🇧🇯', iso2: 'BJ' },
  { code: '+226', country: 'Burkina Faso', flag: '🇧🇫', iso2: 'BF' },
  { code: '+238', country: 'Cape Verde', flag: '🇨🇻', iso2: 'CV' },
  { code: '+241', country: 'Gabon', flag: '🇬🇦', iso2: 'GA' },
  { code: '+220', country: 'Gambia', flag: '🇬🇲', iso2: 'GM' },
  { code: '+224', country: 'Guinea', flag: '🇬🇳', iso2: 'GN' },
  { code: '+245', country: 'Guinea-Bissau', flag: '🇬🇼', iso2: 'GW' },
  { code: '+266', country: 'Lesotho', flag: '🇱🇸', iso2: 'LS' },
  { code: '+231', country: 'Liberia', flag: '🇱🇷', iso2: 'LR' },
  { code: '+223', country: 'Mali', flag: '🇲🇱', iso2: 'ML' },
  { code: '+222', country: 'Mauritania', flag: '🇲🇷', iso2: 'MR' },
  { code: '+227', country: 'Niger', flag: '🇳🇪', iso2: 'NE' },
  { code: '+232', country: 'Sierra Leone', flag: '🇸🇱', iso2: 'SL' },
  { code: '+211', country: 'South Sudan', flag: '🇸🇸', iso2: 'SS' },
  { code: '+268', country: 'Eswatini', flag: '🇸🇿', iso2: 'SZ' },
  { code: '+228', country: 'Togo', flag: '🇹🇬', iso2: 'TG' },
  { code: '+253', country: 'Djibouti', flag: '🇩🇯', iso2: 'DJ' },
  { code: '+269', country: 'Comoros', flag: '🇰🇲', iso2: 'KM' },
  { code: '+239', country: 'São Tomé and Príncipe', flag: '🇸🇹', iso2: 'ST' },
  { code: '+236', country: 'Central African Republic', flag: '🇨🇫', iso2: 'CF' },
  { code: '+243', country: 'Democratic Republic of the Congo', flag: '🇨🇩', iso2: 'CD' },
];

// Alphabetically sorted by country name
export const phoneCodesSorted = [...phoneCodes].sort((a, b) => 
  a.country.localeCompare(b.country)
);
